import Popover from "flowbite/lib/esm/components/popover"
import PopperBase from "./popper_base"

// Flowbite popover on its trigger — see popper_base.js.
//
//   <button data-controller="popover" data-popover-id-value="info"
//           data-popover-trigger-type-value="click">…</button>
//   <div id="info" role="tooltip">…</div>
export default class extends PopperBase {
  static values = {
    placement: { type: String, default: "top" },
    triggerType: { type: String, default: "hover" },
    offset: { type: Number, default: 10 },
  }

  _create(target, instanceId) {
    return new Popover(
      target,
      this.element,
      {
        placement: this.placementValue,
        triggerType: this.triggerTypeValue,
        offset: this.offsetValue,
      },
      { id: instanceId, override: false },
    )
  }
}
